import { render, staticRenderFns } from "./CardWithBack.vue?vue&type=template&id=55b848cf&scoped=true&"
import script from "./CardWithBack.vue?vue&type=script&lang=js&"
export * from "./CardWithBack.vue?vue&type=script&lang=js&"
import style0 from "./CardWithBack.vue?vue&type=style&index=0&id=55b848cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b848cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
